var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "elo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_107",
    "data-name": "Caminho 107",
    d: "M40,21.875A3.244,3.244,0,0,1,36.667,25H3.333A3.244,3.244,0,0,1,0,21.875V3.125A3.244,3.244,0,0,1,3.333,0H36.667A3.244,3.244,0,0,1,40,3.125Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_108",
    "data-name": "Caminho 108",
    d: "M36.667,0H3.333A3.244,3.244,0,0,0,0,3.125v18.75A3.244,3.244,0,0,0,3.333,25H36.667A3.244,3.244,0,0,0,40,21.875V3.125A3.244,3.244,0,0,0,36.667,0Zm0,.625a2.59,2.59,0,0,1,2.667,2.5v18.75a2.59,2.59,0,0,1-2.667,2.5H3.333a2.59,2.59,0,0,1-2.667-2.5V3.125A2.59,2.59,0,0,1,3.333.625Z",
    fill: "none",
    opacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27",
    transform: "translate(5.851 7.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_109",
    "data-name": "Caminho 109",
    d: "M42.176,19.147a1.862,1.862,0,0,1-2.414,1.391l-.413,1.235a3.167,3.167,0,0,0,4.1-2.365Zm-3.919,2,.862-.975a1.861,1.861,0,0,1,0-2.787l-.863-.975a3.163,3.163,0,0,0,0,4.737Zm1.505-4.134A1.863,1.863,0,0,1,42.176,18.4l1.276-.26a3.166,3.166,0,0,0-4.1-2.369S39.762,17.009,39.762,17.009Zm-3.819-2.821v6.105L37,20.733l-.5,1.2L35.453,21.5a1.191,1.191,0,0,1-.516-.433,1.367,1.367,0,0,1-.2-.757V14.189Zm-4.827,1.425a3.163,3.163,0,0,0-2.7,4.887l5.727-2.448A3.162,3.162,0,0,0,31.116,15.613Zm-1.9,3.357a1.658,1.658,0,0,1-.011-.224,1.861,1.861,0,0,1,3.283-1.173ZM32.37,20.1a1.849,1.849,0,0,1-2.291.244l-.692,1.1a3.157,3.157,0,0,0,3.891-.414Z",
    transform: "translate(-15.154 -12.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_110",
    "data-name": "Caminho 110",
    d: "M18.712,20.918a3.051,3.051,0,0,1-3.954,2.28l-.677,2.023A5.186,5.186,0,0,0,20.8,21.347Z",
    transform: "translate(-10.545 -15.125)",
    fill: "#ed412f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_111",
    "data-name": "Caminho 111",
    d: "M10.524,21.941l1.413-1.6a3.047,3.047,0,0,1,0-4.565l-1.414-1.6a5.183,5.183,0,0,0,0,7.761",
    transform: "translate(-8.777 -12.879)",
    fill: "#1aa5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M14.759,14.517A3.052,3.052,0,0,1,18.714,16.8l2.09-.426a5.186,5.186,0,0,0-6.721-3.88Z",
    transform: "translate(-10.546 -12.228)",
    fill: "#ffca32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElo);
export default __webpack_public_path__ + "static/media/elo.dc08d451ca443ea69df6f7ce8b49f53f.svg";
export { ForwardRef as ReactComponent };